import { AnchorHTMLAttributes, ReactElement, ReactNode } from "react";
import {
    AUTHENTICATION_STORED_ITEM,
    authenticationFlag,
    authenticationProperty,
} from "../../shared/utils/authentication-item.utils";
import { useStoredItem } from "../../state/InternalContext";
import { useAuth } from "../internal/AuthProvider";
import { AuthActionAnchor } from "./auth-action-anchor";
import { ChangePasswordButton } from "./ChangePasswordButton";

interface LoginButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: ReactNode;
}

/**
 * Deprecated composite control. Prefer SignInButton, LogoutButton, and ChangePasswordButton.
 * Still switches between login and logout, and still renders ChangePasswordButton when signed in.
 */
export function LoginButton({ children, ...anchorProps }: LoginButtonProps): ReactElement | null {
    const item = useStoredItem(AUTHENTICATION_STORED_ITEM);
    const { showLogin, logout } = useAuth();
    const name = authenticationProperty(item, "name");
    const email = authenticationProperty(item, "email");

    if (authenticationFlag(item, "loading")) {
        return null;
    }

    if (authenticationFlag(item, "showLogout")) {
        return (
            <>
                <AuthActionAnchor
                    {...anchorProps}
                    defaultLabel={`Logout (${name || email || "User"})`}
                    title="Logout"
                    onAction={() => {
                        void logout();
                    }}
                >
                    {children}
                </AuthActionAnchor>
                <ChangePasswordButton />
            </>
        );
    }

    return (
        <AuthActionAnchor {...anchorProps} defaultLabel="Login" title="Login" onAction={showLogin}>
            {children}
        </AuthActionAnchor>
    );
}
